import { render, staticRenderFns } from "./InscricaoEdit_v3.vue?vue&type=template&id=63bf46d6&scoped=true"
import script from "./InscricaoEdit_v3.vue?vue&type=script&lang=js"
export * from "./InscricaoEdit_v3.vue?vue&type=script&lang=js"
import style0 from "./InscricaoEdit_v3.vue?vue&type=style&index=0&id=63bf46d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf46d6",
  null
  
)

export default component.exports